import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatHint, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatButton } from '@angular/material/button';
import { EmployeeCalendarRegisterNotificationRequest } from 'src/app/models/employee_calendar_register_notification_request.model';

export interface CalendarEventNotificationDialogData {
  notification?: EmployeeCalendarRegisterNotificationRequest | null;
}

@Component({
  selector: 'app-calendar-event-notification-dialog',
  templateUrl: './calendar-event-notification-dialog.component.html',
  styleUrl: './calendar-event-notification-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    MatOption,
    MatHint,
    MatError,
    MatButton,
  ],
})
export class CalendarEventNotificationDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CalendarEventNotificationDialogComponent>>(MatDialogRef);
  data = inject<CalendarEventNotificationDialogData>(MAT_DIALOG_DATA);
  private fb = inject(UntypedFormBuilder);

  notificationForm!: UntypedFormGroup;

  constructor() {
    this.notificationForm = this.fb.group({
      minutes_before: [0, [Validators.required, Validators.min(0)]],
      channels: [[], [Validators.required, Validators.minLength(1)]],
    });
  }

  ngOnInit(): void {
    if (this.data.notification) {
      this.notificationForm.patchValue({
        minutes_before: this.data.notification.minutes_before,
        channels: this.data.notification.channels,
      });
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.notificationForm.invalid) {
      return;
    }

    const formValue = this.notificationForm.value;
    const notification: Partial<EmployeeCalendarRegisterNotificationRequest> = {
      id: this.data.notification?.id ?? 0,
      minutes_before: formValue.minutes_before,
      channels: formValue.channels,
      notified_at: this.data.notification?.notified_at,
      created_at: this.data.notification?.created_at ?? new Date(),
      updated_at: new Date(),
    };

    this.dialogRef.close(notification);
  }
}
